import { render, staticRenderFns } from "./ProcessDocumentationNeeded.vue?vue&type=template&id=ac8aef60&"
import script from "./ProcessDocumentationNeeded.vue?vue&type=script&lang=js&"
export * from "./ProcessDocumentationNeeded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports